import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	mappingModalTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-title',
		defaultMessage: 'Select new priorities',
		description: 'Mapping modal title for mapping for the current scheme',
	},
	mappingModalAddSchemeDescription: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-add-scheme-description',
		defaultMessage:
			'Some issues in the projects you’ve selected use priorities that aren’t available in the “{schemeName}” scheme.',
		description: 'Mapping modal description for adding a priority scheme',
	},
	mappingModalSelectNewPrioritiesDescription: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-select-new-priorities-description',
		defaultMessage: 'Select new priorities to replace the current ones. {learnMoreLink}',
		description: 'Mapping modal description to select new priorities to replace existing ones',
	},
	mappingModalLearnMoreLink: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-learn-more-link',
		defaultMessage: 'Learn more',
		description: 'Link to help docs for mapping priorities',
	},
	mappingModalEditSchemeDescription: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-edit-scheme-description',
		defaultMessage:
			'You’re updating the “{schemeName}” scheme with projects and priorities, and some issues use priorities that aren’t available in the projects. This may be due to the following reasons:',
		description:
			'Mapping modal description for editing a scheme. The full message is: You’re updating the “{schemeName}”scheme with projects and priorities, and some issues use priorities that aren’t available in the projects. This may be due to the following reasons: *You’re removing some priorities that were previously associated with this scheme *You’re removing projects from this scheme and they’ll be associated with the “default priority scheme” *You’re adding projects that have previously associated priorities to this scheme',
	},
	mappingModalEditSchemeAddProjectsListItemOne: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-edit-scheme-add-projects-list-item-one',
		defaultMessage:
			'You’re adding projects that have previously associated priorities to this scheme',
		description:
			'Mapping modal description for editing a scheme. The full message is: You’re updating the “{schemeName}”scheme with projects and priorities, and some issues use priorities that aren’t available in the projects. This may be due to the following reasons: *You’re adding projects that have previously associated priorities to this scheme',
	},
	mappingModalEditSchemeDescriptionRemoveProjectsListItemOne: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-edit-scheme-description-remove-projects-list-item-one',
		defaultMessage:
			'You’re removing some priorities that were previously associated with this scheme',
		description:
			'Mapping modal description for editing a scheme. The full message is: You’re updating the “{schemeName}”scheme with projects and priorities, and some issues use priorities that aren’t available in the projects. This may be due to the following reasons: *You’re removing some priorities that were previously associated with this scheme *You’re removing projects from this scheme and they’ll be associated with the “default priority scheme”',
	},
	mappingModalEditSchemeDescriptionRemoveProjectsListItemTwo: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-edit-scheme-description-remove-projects-list-item-two',
		defaultMessage:
			'You’re removing projects from this scheme and they’ll be associated with the “default priority scheme”',
		description:
			'Mapping modal description for editing a scheme. The full message is: You’re updating the “{schemeName}”scheme with projects and priorities, and some issues use priorities that aren’t available in the projects. This may be due to the following reasons: *You’re removing some priorities that were previously associated with this scheme *You’re removing projects from this scheme and they’ll be associated with the “default priority scheme”',
	},
	mappingModalNextButtonTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-next-button-title',
		defaultMessage: 'Next',
		description: 'button title for transitioning to next priority scheme',
	},
	mappingModalSaveButtonTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-save-button-title',
		defaultMessage: 'Save',
		description: 'button title for editing priority scheme',
	},
	mappingModalAddSchemeButtonTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-add-scheme-button-title',
		defaultMessage: 'Add scheme',
		description: 'button title for creating priority scheme',
	},
	mappingModalBackButtonTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.mapping-modal-back-button-title',
		defaultMessage: 'Back',
		description: 'button title to return to the previous modal',
	},
	addPrioritySchemeButtonTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.add-priority-scheme-button-title',
		defaultMessage: 'Add scheme',
		description: 'button title for adding a new priority scheme via modal',
	},
	editPrioritySchemeButtonTitle: {
		id: 'admin-pages-priority-schemes.priority-scheme-modal.edit-priority-scheme-button-title',
		defaultMessage: 'Save',
		description: 'button title for editing an existing priority scheme via modal',
	},
});

export default messages;
